import MaterialTable from '@material-table/core'
import { Typography } from '@mui/material'
import HeaderWithExportOptions from 'components/HeaderWithExportOptions'
import Spinner from 'components/Spinner'
import ViewMoreBtn from 'components/viewMoreBtn'
import React, { useContext, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import useSWR from 'swr'
import { DepositContext } from '../context'
import SingleDepositDetails from './SingleDepositDetails'
import Filter from 'components/Filter'
import { CSV } from 'components/CSV'
import TablePaginationDemo from 'components/Paginator'
import { useLocation } from 'react-router-dom'

export default withTranslation()(function DepositTable({ t }) {
    const [params, setParams] = useState()

    const { setDisplaySingleDeposit, setSingleDepositsData } = useContext(DepositContext)
    const location = useLocation()
    useEffect(() => {
        setParams(location.search)
    }, [location])

    const { data: deposits, isValidating } = useSWR(`transactions/type/deposit${params}`)
    const head = ['Date', 'Action-By', 'Deposit-Amount', 'Fee', 'Total', 'Status']
    const rest = deposits?.data?.data?.map(y => [y?.date, y?.username, y?.gross_amount, y?.fee, y?.total, y?.status])
    const csvData = rest ? [head, ...rest] : []
    const pageDetails = deposits?.data
    return (
        <div className='p-[24px] rounded-[16px] bg-white'>
            <HeaderWithExportOptions
                title={<div className='font-[700] font-[24px]'> Deposits </div>}
                exportOptions={[
                    {
                        name: t('settlements.table.filter'),
                        Content: () => <>
                            <Filter page='deposits' />
                        </>,
                        click: 'filter'
                    },
                    {
                        name: t('transaction.table.export_csv'),
                        Content: () => <CSV fileName='deposits.csv' csvData={csvData} />,
                        click: 'export'
                    }
                ]}
            />

            <SingleDepositDetails />

            {
                !isValidating ?
                    <MaterialTable

                        columns={[
                            { title: 'Date', field: 'date', render: (data) => <span>{data.date}</span> },
                            { title: 'Action By', field: 'username', render: (data) => <span>{data.username}</span> },
                            {
                                title: 'Deposit amount (NGN)', field: 'formatted_gross_amount', headerStyle: { fontSize: '13px' }, cellStyle: { textAlign: 'left' }, render: (data) => {
                                    return <span>{data.gross_amount}</span>
                                }
                            },
                            { title: 'Type', field: 'transaction', render: (data) => <span>{data.transaction}</span> },
                            { title: 'Fee (NGN)', field: 'fee', render: (data) => <span>{data.fee}</span> },
                            { title: 'Total', field: 'total', render: (data) => <span>{data.total}</span> },
                            { title: 'Status', field: 'status', render: ({ status }) => <Typography sx={{ bgcolor: 'rgba(68, 196, 161, 0.12' }} className={`d-inline p-2 w-[fit-content] text-[${status === 'completed' ? '#44C4A1' : '#F2994A'}] border border-[${status === 'success' ? '#44C4A1' : '#F2994A'}] rounded-md`} >{status}</Typography> },
                        ]}
                        options={{
                            headerStyle: {
                                color: '#657585',
                                fontSize: '14px',
                                fontFamily: 'Helvetica Neue',
                                fontStyle: 'normal',
                                fontWeight: 700,
                                lineHeight: '150%',
                                textAlign: 'left'
                            },
                            search: '',
                            actionsColumnIndex: -1,
                            pageSize:pageDetails?.per_page

                        }}
                        localization={{
                            header: {
                                actions: ""
                            }
                            ,
                            body: {}
                        }}
                        data={!isValidating && deposits?.data?.data}
                        title={''}
                        actions={[
                            {
                                icon: ViewMoreBtn,

                                tooltip: 'View full data',
                                onClick: (click, data) => { setDisplaySingleDeposit(false); setSingleDepositsData(data) }

                            }
                        ]}

                        components={{
                            Action: ({ data }) => (
                                <>
                                    {/* <ViewMoreBtn click={() => { setDisplaySingleDeposit(false); setSingleDepositsData(data) }} /> */}
                                </>
                            ),
                            Pagination: ({ data }) => (<TablePaginationDemo {...pageDetails} />)
                        }}
                    />
                    :
                    <Spinner data={deposits?.data?.data} />
            }
        </div>
    )
})
